<template lang="pug">
  v-autocomplete(
    v-model="inputValue"
    :search-input.sync="search"
    :label="label"
    :items="items"
    item-text="name"
    :item-value="returnName ? 'name' : 'id' "
    :multiple="multiple"
    v-bind="$attrs"
    v-on="$listeners"
    :loading="loading"
    clearable
  )
</template>

<script>
import { CRUDProjectRoles } from '@/services/API/_crud';

export default {
  props: {
    returnName: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    value: { type: Number, default: null },
    label: { type: String, default: 'Роль пользователя' },
    projectId: { type: Number, required: false, default: null },
  },
  data() {
    return {
      items: [],
      loading:false,
      search: '',
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  watch:{
    projectId() {
      this.inputValue = null;
      this.search = '';
      this.$emit('input', null);
      this.init();
    },
    search() {
      // Items have already been requested
      if (this.loading) return;
      if (this.inputValue) return;
      this.loading = true;

      // Lazily load input items
      this.loadItems();
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.loadItems();
    },
    async loadItems() {
      const params = {
        'search[name]' :this.search,
      };
      if (this.projectId) params['search[project_id]'] = this.projectId;

      this.loading = true;
      try {
        await CRUDProjectRoles.getAll(params).then((response) => {
          this.items = response.data.data;
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
